import { findComponentByKey } from "../../../utils/helpers";
import { isValidNumber, updateFormConditions } from "./form.service";

export const checkFieldValidity = (addressList, getFieldState) =>
  addressList.every((field) => {
    const { error: errorField, invalid } = getFieldState(field.key);
    return !errorField && !invalid;
  });

export const updateGeoCodes = (sourceKey, data, setValue) => {
  const getCodeTagsToUpdate = ["latitude", "longitude"];
  getCodeTagsToUpdate.forEach((tag) => {
    const key = `${sourceKey}${tag.charAt(0).toUpperCase()}${tag.slice(1)}`;
    let code = data?.[tag];
    code = isValidNumber(code) ? `${code > 0 ? "+" : ""}${code}` : "";
    setValue(key, code, { shouldValidate: true });
  });
};

export const getFormattedFieldKey = (key = "") =>
  key.endsWith("-df") || key.endsWith("-pd") ? key.slice(0, -3) : key;

const getFieldKeysPresentOnRows = (rows) => {
  const keys = [];
  if (!rows.length) return keys;
  rows.forEach((row) => {
    row?.forEach((col) => {
      col?.components?.forEach((field) => {
        if (field?.key) keys.push(field.key);
      });
    });
  });
  return keys;
};

// this function will transform regular formData to dialog formData eg: {genInfoLicenseType:"test"} ==> {genInfoLicenseType-df:"test"} && vice versa
export const getTransformedAppData = (data, form, shouldTransformKey) => {
  if (!form?.components) return data;
  const formData = {};
  form.components.forEach((component) => {
    if (component?.type === "panel" && component.components) {
      component.components.forEach((item) => {
        const { key, type, components, rows } = item || {};
        if (type === "datagrid" && components) {
          let dgFieldKeys = [];
          const _key = shouldTransformKey ? key : getFormattedFieldKey(key);
          const originalDgList = data[_key] || [];
          components.forEach((comp) => {
            if (comp.type === "table" && comp.rows) {
              dgFieldKeys = getFieldKeysPresentOnRows(comp.rows);
            }
          });
          const dgKey = shouldTransformKey ? getFormattedFieldKey(key) : key;
          formData[dgKey] = originalDgList.map((record) => {
            const mappedValues = {};
            dgFieldKeys.forEach((fieldKey) => {
              if (shouldTransformKey)
                mappedValues[getFormattedFieldKey(fieldKey)] = record[fieldKey];
              else
                mappedValues[fieldKey] = record[getFormattedFieldKey(fieldKey)];
            });
            return { ...record, ...mappedValues };
          });
        } else if (type === "table" && rows) {
          const fieldKeys = getFieldKeysPresentOnRows(rows);
          fieldKeys?.forEach((fieldKey) => {
            if (shouldTransformKey)
              formData[getFormattedFieldKey(fieldKey)] = data[fieldKey];
            else formData[fieldKey] = data[getFormattedFieldKey(fieldKey)];
          });
        }
      });
    }
  });
  return formData;
};

export const getFormTemplate = (formTemplate, componentKey) => {
  if (!componentKey) return null;
  const form = findComponentByKey(formTemplate, componentKey);
  return updateFormConditions({ components: [form] }) || null;
};
